import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import { installCsrfFetchInterceptor } from './utils/csrfFetch';

// CSRF-Token global an alle schreibenden fetch()-Requests anhängen
installCsrfFetchInterceptor();

// ============================================
// SENTRY ERROR MONITORING - FRONTEND
// ============================================
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, // 10% of transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1.0, // 100% on error
    // Filter sensitive data
    beforeSend(event) {
      // Remove any PII from breadcrumbs
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.filter(
          (b) => !b.message?.includes('password') && !b.message?.includes('token')
        );
      }
      return event;
    },
  });
  console.log('✅ Sentry Error Monitoring initialized (Frontend)');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);// Build timestamp: 1769791638
